import React, { FunctionComponent } from 'react'
import EasyDynamicEight from 'Shared/components/EasyDynamicEight/EasyDynamicEight'
import PuxAnchor from 'Shared/components/PuxAnchor/PuxAnchor'
import PuxIcon from 'Shared/components/PuxIcon/PuxIcon'
import { t } from 'ttag'

import SignUpForm from './GenericTrialForm'

const PuxNewsletterForm: FunctionComponent = () => {
  const benefits = [
    t`Easy8.Trial.Benefit1`,
    t`Easy8.Trial.Benefit2`,
    t`Easy8.Trial.Benefit3`,
  ]

  return (
    <PuxAnchor id='trial'>
      <div className='TrialBanner'>
        <div className='TrialBanner-container'>
          <div className='TrialBanner-text'>
            <h2 className='TrialBanner-title h1'>{t`Easy8.Trial.Title`}</h2>
            <SignUpForm />
            <ul className='TrialBanner-benefits'>
              {benefits.map((benefit) => (
                <li className='TrialBanner-benefit' key={benefit}>
                  <PuxIcon
                    name='user-interface/c-check'
                    size={16}
                    className='TrialBanner-benefitIcon'
                    decorative
                  />
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className='TrialBanner-image'>
            <EasyDynamicEight
              dynamicEightColor='blue'
              dynamicEightPosition='center'
              dynamicEightSize='l'
              dynamicEightFit='height'
              dynamicEightHeight='100%'
            />
            <img className='laptop' src={process.env.GATSBY_MEDIA_URL + '/system/trial/easy8-private-workops-platfrom-trial.png'} />
          </div>
        </div>
      </div>
    </PuxAnchor>
  )
}

export default PuxNewsletterForm
